<div class="copy-text-dropdown">
  <div class="copy-text-wrap">
    <rt-input
      [value]="text"
      [readOnly]="true"
      (click)="$event.preventDefault()"
      type="text"
      variant="rounded"
    />
    <div class="actions-wrap" margin-top-small-x>
      <rt-button size="small" (click)="edit.emit()" variant="plain" margin-right-small>
        {{ 'app.common.edit' | translate }}
      </rt-button>
      <rt-button (click)="copyToClipboard()" variant="primary" size="small">
        {{ 'app.common.copy' | translate }}
      </rt-button>
    </div>
  </div>
</div>
